import { useState, useEffect } from "react";
import AlphaMediaDashboard from "./components/AlphaMediaDashboard";
import VerifyEmail from "./pages/VerifyEmail";

const BANNER = {
  true:    { bg: "#064E3B", border: "#059669", text: "#D1FAE5", msg: "✓ Email verified successfully — you can now sign in." },
  invalid: { bg: "#431407", border: "#B45309", text: "#FEF3C7", msg: "⚠ That verification link is invalid or has expired. Request a new one from the login screen." },
  error:   { bg: "#450A0A", border: "#B91C1C", text: "#FEE2E2", msg: "⚠ Something went wrong during verification. Please try again or contact tech@alphamedia.co.zw." },
};

function VerifiedBanner({ status, onDismiss }) {
  const b = BANNER[status];
  if (!b) return null;
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
      background: b.bg, borderBottom: `2px solid ${b.border}`,
      padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between",
      fontFamily: "Arial, sans-serif", fontSize: 14, color: b.text,
    }}>
      <span>{b.msg}</span>
      <button onClick={onDismiss} style={{
        background: "transparent", border: "none", color: b.text,
        fontSize: 18, cursor: "pointer", lineHeight: 1, padding: "0 4px",
      }}>×</button>
    </div>
  );
}

const isVerifyPage = window.location.pathname === "/verify";

function App() {
  const [verifiedStatus, setVerifiedStatus] = useState(null);

  useEffect(() => {
    if (isVerifyPage) return;
    const params = new URLSearchParams(window.location.search);
    const v = params.get("verified");
    if (v) {
      setVerifiedStatus(v);
      params.delete("verified");
      const newUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
      window.history.replaceState(null, "", newUrl);
    }
  }, []);

  if (isVerifyPage) return <VerifyEmail />;

  return (
    <div>
      {verifiedStatus && (
        <VerifiedBanner status={verifiedStatus} onDismiss={() => setVerifiedStatus(null)} />
      )}
      <div style={verifiedStatus ? { paddingTop: 48 } : undefined}>
        <AlphaMediaDashboard />
      </div>
    </div>
  );
}

export default App;
